// extracted by mini-css-extract-plugin
export default {"container":"ChangeParent_container__fTdEs","input":"ChangeParent_input__gen4s","select":"ChangeParent_select__UNOUs","button":"ChangeParent_button__bzSbp"};